import { useAppSelector } from '~/hooks/useAppSelector';
import { hasChildOffices } from '~/utils/OfficeUtils';

/**
 * Hook to check if the current user is viewing as a parent office.
 * Returns true when: the account has child offices AND the parent office is currently selected.
 */
export const useIsParentOfficeSelector = () => {
  const isParentOffice = useAppSelector(
    (state) =>
      hasChildOffices(state.user?.childOffices) &&
      state.user?.selectedChildOffice?.id === state.user?.user?.id,
  );

  return isParentOffice;
};
